import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FilterService } from './filter/filter.service';

import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogComponentInjectedData, ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  templateUrl: './dashboard-forms.component.html',
  styleUrls: ['./dashboard-forms.component.scss']
})
export class DashboardFormsComponent {

  public hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');

  constructor(
    private matDialog: MatDialog,
    public filterService: FilterService,
    private authenticationService: AuthenticationService,
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ){
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public exportFormAnswers(): void {
    this.matDialog.open(ExportDialogComponent, {
      panelClass: 'export-dialog',
      autoFocus: false,
      data: {
        type: ExportDialogTypeEnum.formAnswers,
        where: { ...this.filterService.toDetailQuery() }
      } as ExportDialogComponentInjectedData
    });
  }
}
